import useGetApplications from './useGetApplications'

export default useGetApplications
